module.exports = function(data) {
var __t, __p = '';
__p += '<div class=\'calculated\'>' +
((__t = ( data.calculatedValue )) == null ? '' : __t) +
'</div>\n<div class=\'vals\'>\n    <span>' +
((__t = (data.val1_label)) == null ? '' : __t) +
'</span>\n    <div class=\'val1\'>' +
((__t = ( data.val1 )) == null ? '' : __t) +
' </div>\n    <span>' +
((__t = (data.val2_label)) == null ? '' : __t) +
'</span>\n    <div class=\'val2\'>' +
((__t = ( data.val2 )) == null ? '' : __t) +
' </div>\n</div>\n\n';
return __p
}